var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 5.06885L7.5862 18.724H6.82758V41.4826H37.1724V39.9654V18.724L22 5.06885Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1999 37.7617H28.5999V29.3807H15.4V37.7617H8.79996V18.5127L21.9779 5.96222L35.1999 18.5524V37.7617ZM39.5999 16.8177V16.8093L22.0043 0.0473633L0 20.983L3.10417 23.9457L4.40001 22.7031V41.9521H19.8V33.5712H24.2V41.9521H39.5999V41.9459V22.7429L40.8869 23.9666L44.0021 21.004L39.5999 16.8177Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon2);
export default __webpack_public_path__ + "static/media/home-icon-2.52bb3f90f19cd261c4d641731754765a.svg";
export { ForwardRef as ReactComponent };